import React from 'react';
import { App } from 'antd';
import { useCopyToClipboard } from '../../hooks/copyToClipboard';
import './index.scss';

export const CopyToClipboard = ({ content, value, successMessage }) => {
    const copyText = useCopyToClipboard();
    const { message } = App.useApp();

    const handleCopyIp = async () => {
        const success = await copyText(value);
        if (success) message.success(successMessage);
    };

    return (
        <button className='copy-button' onClick={handleCopyIp} style={{ cursor: 'pointer' }}>
            {content}
        </button>
    );
};
